<template>
    <div>   
        <!-- {{ coinPrices }} -->
        <svg :width="svgWidth" :height="svgHeight">
          <path :d="generatePath(coinData[2].sparkline_in_7d, 0)" :stroke="'green'" stroke-width="2" fill="none" />
        </svg>
      <br></br>
      <span style="color:red">{{ coinData }}</span>
    </div>
  </template>

  <script>
  import axios from 'axios';
  
  export default {
    data() {
      return {
        svgWidth: 300,
        svgHeight: 100,
        coinData: []
      };
    },
    methods: {
        async fetchBitcoinPriceData(ids) {
            const endpoint = 'https://api.coingecko.com/api/v3/coins/markets?x_cg_demo_api_key=CG-UhwnpGqWNHeMipRrQ8Wr5Yxr';
            const params = {
                vs_currency: 'usd',
                days: 0, // Fetch 7 days of data
                interval: 'daily',
                ids:ids,
                order: 'market_cap_desc', // Order by market capitalization
                per_page: 2, // Number of coins per page
                page: 1, // Page number
                sparkline: true // Disable sparkline
            };

            try {
                const response = await axios.get(endpoint, {
                    params: params,
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CoinGecko-Api-Key': 'CG-UhwnpGqWNHeMipRrQ8Wr5Yxr'
                    }
                });
                
                console.log('Bitcoin price data:', response.data);
                
               
                // Truncate sparkline_in_7d to include only the last 7 days
                const coinData = response.data.map(coin => {
                    const sparklineData = coin.sparkline_in_7d.price.slice(-7); // Get the last 7 days
                    return { ...coin, sparkline_in_7d: sparklineData };
                });

                
                this.coinData = this.coinData.concat(coinData);
                
            } catch (error) {
                console.error('Error fetching Bitcoin price data:', error);
            }
        },
        generatePath(priceData, index) {
          const dataLength = priceData.length;
          const priceMax = Math.max(...priceData);
          const priceMin = Math.min(...priceData);
          const priceRange = priceMax - priceMin;
          const xStep = this.svgWidth / (dataLength - 1);

          let path = `M0 ${this.svgHeight - ((priceData[0] - priceMin) / priceRange) * this.svgHeight}`;
          for (let i = 1; i < dataLength; i++) {
            const x = i * xStep;
            const y = this.svgHeight - ((priceData[i] - priceMin) / priceRange) * this.svgHeight;
            path += ` L${x} ${y}`;
          }

          return path;
        }
        
    },
    
      
      
    mounted() {
      this.fetchBitcoinPriceData( 'bitcoin,ethereum');
      
      this.fetchBitcoinPriceData( 'tether,binancecoin');
    }
  };
  </script>
  